import { faMultiply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { FaBars } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import ListItem from "./leftBarElements/ListItem";

export default function LeftBar() {
  const location = useLocation().pathname;
  const [menu, setMenu] = useState(false);
  const showMenu = () => {
    setMenu(true);
    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
  };
  const hideMenu = () => {
    setMenu(false);
  };
  return (
    <>
      <div
        className={`bg-themeBlue text-white lg:hidden ${
          !menu ? "flex" : "hidden"
        } justify-end items-center px-4 py-2`}
      >
        <button className="flex justify-end w-full" onClick={showMenu}>
          <FaBars size={32} />
        </button>
      </div>

      <div
        className={`xl:col-span-3 lg:col-span-4 bg-themeBlue py-6 px-4 lg:gap-y-8 lg:flex min-h-[76vh] ${
          menu ? "flex" : "hidden"
        } 
          flex-col gap-x-3 gap-y-4 relative`}
      >
        <button
          className="lg:hidden block text-white absolute right-3 top-3"
          onClick={hideMenu}
        >
          <FontAwesomeIcon icon={faMultiply} className="text-2xl" />
        </button>
        <ListItem
          back={location === "/package_details" ? "bg-white" : "bg-white-light"}
          bor={location === "/package_details" ? "100" : "60"}
          col={location === "/package_details" ? "100" : "60"}
          num="1"
          title="Package Details"
          descReq="hidden"
        />
        {/* <ListItem
          back={location === "/company_details" ? "bg-white" : "bg-white-light"}
          bor={location === "/company_details" ? "100" : "60"}
          col={location === "/company_details" ? "100" : "60"}
          num="2"
          title="Company Details"
          descReq="hidden"
        /> */}
        <ListItem
          back={
            location === "/supplier_details" ? "bg-white" : "bg-white-light"
          }
          bor={location === "/supplier_details" ? "100" : "60"}
          col={location === "/supplier_details" ? "100" : "60"}
          num="2"
          title="Supplier Details"
          descReq="hidden"
        />
        <ListItem
          back={
            location === "/consignee_details" ? "bg-white" : "bg-white-light"
          }
          bor={location === "/consignee_details" ? "100" : "60"}
          col={location === "/consignee_details" ? "100" : "60"}
          num="3"
          title="Consignee Details"
          descReq="hidden"
        />
        <ListItem
          back={
            location === "/destination_details" ? "bg-white" : "bg-white-light"
          }
          bor={location === "/destination_details" ? "100" : "60"}
          col={location === "/destination_details" ? "100" : "60"}
          num="4"
          title="Destination Details"
          descReq="hidden"
        />
        <ListItem
          back={location === "/order_summary" ? "bg-white" : "bg-white-light"}
          bor={location === "/order_summary" ? "100" : "60"}
          col={location === "/order_summary" ? "100" : "60"}
          num="5"
          title="Review your Order"
          descReq="hidden"
        />
        <ListItem
          back={location === "/place_order" ? "bg-white" : "bg-white-light"}
          bor={location === "/place_order" ? "100" : "60"}
          col={location === "/place_order" ? "100" : "60"}
          num="6"
          title="Place Order"
          descReq="hidden"
        />
      </div>
    </>
  );
}
